import { usePage } from "@/components/page/PageContext";
import RetailSummary from "@/pages/retail/RetailSummary";
import StoreList from "@/pages/retail/StoreList";
import { getRetailReport } from "@/queries/retail";
import { useReportContext } from "@/stores/ReportContext";
import { useSessionData } from "@/stores/SessionDataContext";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

function LoadingState() {
  return (
    <div className="w-full h-full flex items-center justify-center py-12">
      <div className="flex flex-col items-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
        <div className="text-slate-400">
          Loading data. Please wait a moment...
        </div>
      </div>
    </div>
  );
}

function RetailHome() {
  const { restrict_store, stores } = useSessionData();

  const { reportId } = useReportContext();
  const singleStore = !!restrict_store;
  const { store } = useParams();
  const { setTitles } = usePage();

  useEffect(() => {
    setTitles(["Retail Overview"]);
  }, []);

  const storeId = store ? parseInt(store) : null;
  const currentStores = singleStore
    ? []
    : storeId
      ? [storeId]
      : stores.map((s) => s.id);

  // No store in the URL means the "All Stores" view.
  const allStores = !singleStore && storeId === null;

  // Query for current view
  const { isLoading, error } = getRetailReport.useQuery({
    report: Number(reportId),
    stores: currentStores,
    allStores,
  });

  // Only show loading state for initial load
  if (isLoading) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <div className="text-red-500 p-8">
        Error loading data: {error.message}
      </div>
    );
  }

  return (
    <div>
      {!singleStore && <StoreList />}
      <div className={"h-full px-4 md:px-8 py-4"}>
        <RetailSummary stores={currentStores} allStores={allStores} />
      </div>
    </div>
  );
}

export default RetailHome;
